import { createSelector } from '@reduxjs/toolkit';

import { B2BLeadsState, name } from '../reducers/b2bLeads';

export const getB2BLeadsSlice = (state): B2BLeadsState => state[name];
export const b2bLeadsSelector = createSelector([getB2BLeadsSlice], ({ leads }) => leads);
export const b2bLeadsFiltersSelector = createSelector([getB2BLeadsSlice], ({ filters }) => filters);
export const activeB2BLeadIdSelector = createSelector([getB2BLeadsSlice], ({ activeLeadId }) => activeLeadId);
export const activeB2BLeadSelector = createSelector([getB2BLeadsSlice], ({ activeLead }) => activeLead);
export const b2bLeadsNextBeforeIdSelector = createSelector([getB2BLeadsSlice], ({ nextBeforeId }) => nextBeforeId);
export const b2bLeadsHasMoreSelector = createSelector([getB2BLeadsSlice], ({ hasMore }) => hasMore);
export const isB2BLeadsLoadingSelector = createSelector([getB2BLeadsSlice], ({ isLoading }) => isLoading);
export const isB2BActiveLeadLoadingSelector = createSelector([getB2BLeadsSlice], ({ isLoadingActiveLead }) => isLoadingActiveLead);
export const isB2BLeadUpdatingSelector = createSelector([getB2BLeadsSlice], ({ isUpdating }) => isUpdating);
export const b2bLeadsErrorSelector = createSelector([getB2BLeadsSlice], ({ error }) => error);

export const filteredB2BLeadsSelector = createSelector(
  [b2bLeadsSelector, b2bLeadsFiltersSelector],
  (leads, filters) => leads.filter((lead) => {
    if (filters.status !== 'all' && lead.status !== filters.status) return false;
    const query = filters.query.trim().toLowerCase();
    if (!query) return true;
    return [lead.id, lead.name, lead.phone, lead.email, lead.comment]
      .join(' ').toLowerCase().includes(query);
  })
);
